var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"comic",staticClass:"contentPic",attrs:{"id":"totalComics"}},[_c('div',{staticClass:"ComicPicsBox"},[_c('ComicPics',{staticClass:"content",attrs:{"comicId":_vm.comicId}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }